import {UIMHomepageController} from './homepage/UIMHomepageController.ts'
import {UIMLeaderboardController} from './leaderboard/UIMLeaderboardController.ts'
import {UIMLobbyController} from './lobby/UIMLobbyController.ts'
import {UIMStoreController} from './store/UIMStoreController.ts'
import {UIMStoreBodyController} from './store/UIMStoreBodyController.ts'
import {type UIMSceneController} from '../../UIMSceneController.ts'
import {type UIMNavigationController} from '../navigation/UIMNavigationController.ts'
import {type UIMMainPageController} from '../UIMMainPageController.ts'
import {Splide} from '@splidejs/splide'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIMSceneEnum} from '../../../../../../shared/enums/UIMSceneEnums.ts'
import {UIModeSelectorController} from '../../../../../shared/scripts/ui_html/home_page/UIModeSelectorController.ts'
import {UIMModeSelectorDetailsController} from './homepage/UIMModeSelectorDetailsController.ts'
import {mountMorePage} from '../../../../../shared/scripts/more/mountMorePage.ts'
import {navigateToPage} from '../../../../../shared/scripts/ui_utils/ClientUtils.ts'
import {clientIntl} from '../../../../../shared/scripts/ClientI18n.ts'
import {uiManager} from '../../../EntryMobile.ts'
import {StorageWrapper} from '../../../../../shared/scripts/StorageWrapper.ts'

export class UIMBodyController {
    private readonly bodyContainer: HTMLDivElement

    readonly homepageController: UIMHomepageController
    readonly modeSelectorController: UIModeSelectorController
    readonly modeSelectorDetailsController: UIMModeSelectorDetailsController
    readonly lobbyController: UIMLobbyController
    readonly storeController: UIMStoreController

    readonly swipeNavigation: Splide
    readonly sceneController: UIMSceneController
    readonly navigationController: UIMNavigationController

    constructor(sceneController: UIMSceneController, mainpageController: UIMMainPageController) {
        this.bodyContainer = document.getElementById('main-page-body-container') as HTMLDivElement

        const initTimestamp = Date.now()
        this.homepageController = new UIMHomepageController()

        this.modeSelectorDetailsController = new UIMModeSelectorDetailsController((matchType) => {
            void this.homepageController.matchmakingController.startGame(matchType)
        }, (matchType) => {
            this.modeSelectorController.redirectToCasualWithTransition(matchType)
        }, sceneController)

        this.modeSelectorController = new UIModeSelectorController(initTimestamp, (matchType) => {
            void this.homepageController.matchmakingController.startGame(matchType)
        }, (matchType) => {
            this.modeSelectorDetailsController.show(matchType)
        })

        new UIMLeaderboardController()
        this.lobbyController = new UIMLobbyController()
        this.storeController = new UIMStoreController()
        mountMorePage('more-page-container', () => {
            navigateToPage(`${clientIntl.getLanguagePathPrefix()}/catan-rules?style=mobile`, false, true)
            const currentScene = uiManager.sceneController.scene
            if(currentScene == undefined) return
            StorageWrapper.setLastScene(currentScene)
        })
        this.sceneController = sceneController

        this.navigationController = mainpageController.navigationController
        this.swipeNavigation = new Splide('.splide', {
            type: 'slide',
            perPage: 1,
            start: 2,
            arrows: false,
            pagination: false,
            flickMaxPages: 1,
            flickPower: 100,
            perMove: 1,
            noDrag: 'input, textarea, .m-no-drag',
        }).mount()

        const track = document.getElementById('splide01-track')
        if(track) {
            track.addEventListener('touchstart', (e: TouchEvent) => {
                if(e.touches.length > 1) this.swipeNavigation.refresh()
            })
        }

        let didUserSwipe = false
        this.swipeNavigation.on('drag', () => {
            didUserSwipe = true
        })
        this.swipeNavigation.on('move', (e: number) => {
            if(!didUserSwipe) return
            didUserSwipe = false
            this.slideChange(e)
        })
    }

    private slideChange(scene: number) {
        const isStoreHidden = UIUtilsEjsVariables.shouldHideStoreOnMobile
        const mappedScene = isStoreHidden && scene >= UIMSceneEnum.Store ? scene + 1 : scene
        this.sceneController.loadScene(mappedScene)
    }

    hide() {
        this.bodyContainer.style.display = 'none'
        this.homepageController.onHomepageHide()
    }

    show() {
        this.bodyContainer.style.display = 'block'
    }

    onHomepageShow() {
        this.modeSelectorController.onHomepageShow()
    }

    onStoreShow() {
        if(!(this.storeController.bodyController instanceof UIMStoreBodyController)) return
        this.storeController.bodyController.onStoreViewVisible()
    }
}
